import React, { useEffect, useState } from "react";
import "./Style.css";
import BeatLoader from "react-spinners/BeatLoader";
import { EntryHeader } from "../../E-check/style";
import { PageHeader } from "../../page-header";
import { useEntrys } from "../../../hooks/useEntrys";
import moment from "moment";

export default function Receivables() {

  const { fetchReceivables, receivables, receivablesLoader } = useEntrys();

  const [period, setPeriod] = useState("today");
  const [page, setPage] = useState(1);

  const [initialDate, setInitialDate] = useState("");
  const [finalDate, setFinalDate] = useState("");

  const pages = () => {
    return [{ name: 'Recebiveis', link: '/pagina-inicial' }];
  };

  const formatMoney = (value) => {
    if (!value) return "R$ 0,00";

    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  };

  const getDates = () => {

    if (period === "custom") {
      return {
        initial: initialDate,
        final: finalDate
      };
    }

    const today = new Date();
    const start = new Date();

    if (period === "7days") start.setDate(today.getDate() - 7);
    if (period === "30days") start.setDate(today.getDate() - 30);
    if (period === "today") start.setDate(today.getDate());

    const format = (date) => date.toISOString().split("T")[0];

    return {
      initial: format(start),
      final: format(today)
    };
  };

  function formatPaymentDate(date) {
    if (!date) return "-";

    const parsed = moment(date);

    if (!parsed.isValid()) return "-";

    return parsed.format("DD/MM/YYYY");
  }

  const loadReceivables = (currentPage = 1) => {

    const { initial, final } = getDates();

    if (!initial || !final) return;

    fetchReceivables(initial, final, currentPage);
  };

  useEffect(() => {
    loadReceivables(page);
  }, [period, page]);

  useEffect(() => {
    if (period === "custom") {
      loadReceivables(1);
    }
  }, [initialDate, finalDate]);

  const formatStatus = (status) => {
    if (!status) return "-";

    const map = {
      APROVADA: {
        label: "Agendado",
        className: "status-badge status-agendada"
      },
      LIQUIDADA: {
        label: "Liquidada",
        className: "status-badge status-liquidada"
      }
    };

    return map[status] || { label: status, className: "status-badge" };
  };

  const data = receivables?.data;
  const pagination = receivables?.pagination;

  return (
    <div className="pagina-pix">
      <div className="col-md-10 pagina-pix-container">

        <EntryHeader>
          <div className="col-xl-12">
            <PageHeader title="Relatório de Liquidação" pages={pages()} />
          </div>
        </EntryHeader>

        <div className="body">

          {/* FILTROS */}

          <div className="filters-container">

            <select
              className="form-control period-select"
              value={period}
              onChange={(e) => {
                setPage(1);
                setPeriod(e.target.value);
              }}
            >
              <option value="today">Hoje</option>
              <option value="7days">Últimos 7 dias</option>
              <option value="30days">Últimos 30 dias</option>
              <option value="custom">Personalizado</option>
            </select>

            {period === "custom" && (
              <>
                <input
                  type="date"
                  className="form-control"
                  value={initialDate}
                  onChange={(e) => setInitialDate(e.target.value)}
                />

                <input
                  type="date"
                  className="form-control"
                  value={finalDate}
                  onChange={(e) => setFinalDate(e.target.value)}
                />
              </>
            )}

          </div>

          {receivablesLoader ? (
            <div className="d-flex justify-content-center">
              <BeatLoader size={12} />
            </div>
          ) : (
            <>

              {/* TOTALIZADORES */}

              <div className="row mb-1">

                <div className="col-md-3">
                  <div className="receivable-card">
                    <p>Valor Bruto</p>
                    <h4>{formatMoney(data?.grossAmount)}</h4>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="receivable-card">
                    <p>Valor Líquido</p>
                    <h4>{formatMoney(data?.netAmount)}</h4>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="receivable-card">
                    <p>Total de Taxas</p>
                    <h4>{formatMoney(data?.totalOperation)}</h4>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="receivable-card">
                    <p>Spread</p>
                    <h4>{formatMoney(data?.spread)}</h4>
                  </div>
                </div>

              </div>

              {/* TABELA */}

              <div className="table-responsive">

                <table className="table table-striped">

                  <thead>
                    <tr>
                      <th className="text-center">ID</th>
                      <th className="text-center">NSU</th>
                      <th>Bandeira</th>
                      <th>Modo</th>
                      <th>Parcela</th>
                      <th>Valor</th>
                      <th>Taxa</th>
                      <th>Líquido</th>
                      <th className="text-center">Status</th>
                      <th>Data Criação</th>
                      <th>Data Pagamento</th>
                    </tr>
                  </thead>

                  <tbody>

                    {data?.receivables?.map((item) => (
                      <tr key={item.id}>

                        <td>{item.id}</td>
                        <td>{item.nsu}</td>
                        <td>{item.flagCard}</td>
                        <td>{item.transactionMode}</td>
                        <td className="text-center" >{item.installment}/{item.totalInstallments}</td>
                        <td>{formatMoney(item.totalAmount)}</td>
                        <td>{formatMoney(item.operation)}</td>
                        <td>{formatMoney(item.netAmount)}</td>
                        <td>
                          <span className={formatStatus(item.status).className}>
                            {formatStatus(item.status).label}
                          </span>
                        </td>
                        <td className="text-center">{moment(item.dtCreation).format("DD/MM/YYYY")}</td>
                        <td className="text-center">
                          {formatPaymentDate(item.dtPayment)}
                        </td>

                      </tr>
                    ))}

                  </tbody>

                </table>

              </div>

              {/* PAGINAÇÃO */}

              <div className="pagination-container">

                <button
                  disabled={!pagination?.hasPreviousPage}
                  onClick={() => setPage(page - 1)}
                >
                  Anterior
                </button>

                <span>
                  Página {pagination?.currentPage} de {pagination?.totalPages}
                </span>

                <button
                  disabled={!pagination?.hasNextPage}
                  onClick={() => setPage(page + 1)}
                >
                  Próxima
                </button>

              </div>

            </>
          )}

        </div>
      </div>
    </div>
  );
}